import {
  Typography,
  TableContainer,
  Paper,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
} from '@mui/material';
import { useRootStore } from '../../../../stores/rootStore';

const PROPERTY_METRICS = [
  {
    metricId: '63',
    displayName: 'Total Dwellings',
    definition: 'The number of dwelling located within the defined area.',
    isAvailableInAU: true,
    isAvailableInNZ: true,
  },
  {
    metricId: '81',
    displayName: 'Average Land Area',
    definition: 'The average size of land of all properties.',
    isAvailableInAU: false,
    isAvailableInNZ: true,
  },
];

export const PropertyMetrics = () => {
  const country = useRootStore(state => state.country);

  return (
    <>
      <Typography id="property-metrics" variant="h6" fontWeight={600} my={0.5}>
        Property Metrics
      </Typography>

      <Typography variant="body2">
        The Property metrics provide statistics based off property's attributes.
      </Typography>

      <br />

      <TableContainer component={Paper}>
        <Table>
          <TableHead sx={{ whiteSpace: 'nowrap' }}>
            <TableRow>
              <TableCell>ID</TableCell>
              <TableCell>Display Name</TableCell>
              <TableCell>Definition</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {PROPERTY_METRICS.filter(metric =>
              country === 'au'
                ? metric.isAvailableInAU
                : metric.isAvailableInNZ,
            ).map(metric => (
              <TableRow>
                <TableCell sx={{ whiteSpace: 'nowrap' }}>
                  {metric.metricId}
                </TableCell>
                <TableCell sx={{ whiteSpace: 'nowrap' }}>
                  {metric.displayName}
                </TableCell>
                <TableCell
                  dangerouslySetInnerHTML={{ __html: metric.definition }}
                />
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
};
